export const DebugRouting = {
  hidden: true,
  path: "/debug",
  name: "debug",
  component: () => import(/* webpackChunkName: "dashboard-welcome" */ "@/views/debug/index.vue"),
  meta: { title: "调试" },
};
